module.exports = __webpack_public_path__ + "img/cover22.42b4fea3.png";